<div class="box-menu-settings active box-menu-settings-wrapper">
	<div class="box-menu-settings active" [class.top-padding]="isResetAnalysisWarning()">

		@if (isResetAnalysisWarning()) {
		<div data-testid="SUBSYS2_CATEGORIZATION_RESET_WARNING_LBL" class="alert alert-warning reset-warning">
			<i class="material-icons md-18 me-3">report_problem</i>
			{{ labels().IMAGE_GARAGE_COMPONENT_RESET_ANALYSIS_WARNING }}
		</div>
		}

		<form>

			<div class="row-box d-flex align-items-center bg-body m-3">
				<h4 data-testid="SUBSYS2_CATEGORIZATION_BONE_LBL" for="boneType" class="me-4">
					{{ labels().IMAGE_ORIENTATION_COMPONENT_BONE_TYPE }}
				</h4>
				<span>{{ form()!.boneSide! | anatomicalSideLabel }} {{ form()!.boneType! | boneTypeLabel }}</span>
			</div>

			@if (isFulllegVisible()) {
			<div class="box-bordered">
				<div class="stepper pe-0">
					<div class="stepper-icon" [class.success]="isFullLeg()">
						a<i class="material-icons">done</i>
					</div>
					<div data-testid="SUBSYS2_CATEGORIZATION_FULLLEG_LBL" class="stepper-label">
						{{ labels().IMAGE_ORIENTATION_COMPONENT_BONE_FULLLEG }}
					</div>
				</div>

				<div class="form-group pb-0 mt-3">
					<div class="custom-control custom-checkbox" style="width: fit-content;">
						<input #fullleg data-testid="SUBSYS2_CATEGORIZATION_FULLLEG_INPUT" type="checkbox"
							class="custom-control-input" id="full-leg" [checked]="isFullLeg()"
							(change)="isFullLeg.set(fullleg.checked)"
							[class]="{'is-invalid': !isFullLeg() && isValidationForced()}" />
						<label class="custom-control-label" for="full-leg">
							{{ labels().IMAGE_ORIENTATION_COMPONENT_BONE_FULLLEG_YES }}
						</label>
					</div>
					@if (!isFullLeg() && isValidationForced()) {
					<div class="invalid-feedback d-block">{{ labels().VALIDATION_MESSAGE_REQUIRED_FULLLEG }}</div>
					}
				</div>
			</div>
			}

			<div class="box-bordered">
				<div class="stepper pe-0">
					@if (isFulllegVisible()) {
					<div class="stepper-icon" [class.success]="isCorrect() !== null">
						b<i class="material-icons">done</i>
					</div>
					} @else {
					<div class="stepper-icon" [class.bg-success]="isCorrect() !== null">
						<i class="material-icons" [class.d-block]="isCorrect() !== null">done</i>
					</div>
					}
					<div data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_LBL" class="stepper-label">
						{{ labels().IMAGE_ORIENTATION_COMPONENT_BONE_ORIENTATION }}
					</div>
					<div class="box-suggestion box-suggestion-minimized" [ngbTooltip]="orientationTooltipContent" placement="left"
						tooltipClass="suggestion-tooltip" container="body"></div>
					<!-- Suggestion orientation tooltip -->
					<ng-template #orientationTooltipContent>
						<div class="box-suggestion box-suggestion-minimized">
							<p data-testid="SUBSYS2_CATEGORIZATION_TOOLINFO_TXT">
								{{ labels().IMAGE_ORIENTATION_COMPONENT_SUGGESTION_MESSAGE }}
							</p>
						</div>
					</ng-template>
				</div>

				<div class="form-group pb-0 mt-3">
					<div class="custom-control custom-radio custom-control-inline me-5">
						<input data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_YES_INPUT" type="radio" id="yesOrientation"
							name="orientation" class="custom-control-input" (change)="changeOrientation(false)"
							[checked]="isCorrect() == false" required
							[class]="{'is-invalid': isCorrect() == null && isValidationForced()}" />
						<label data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_YES_LBL" class="custom-control-label"
							for="yesOrientation">
							{{ labels().IMAGE_ORIENTATION_COMPONENT_BONE_ORIENTATION_YES }}
						</label>
					</div>
					<div class="custom-control custom-radio custom-control-inline">
						<input data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_NO_INPUT" type="radio" id="noOrientation"
							name="orientation" class="custom-control-input" (change)="changeOrientation(true)"
							[checked]="isCorrect() == true" required
							[class]="{'is-invalid': isCorrect() == null && isValidationForced()}" />
						<label data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_NO_LBL" class="custom-control-label"
							for="noOrientation">
							{{ labels().IMAGE_ORIENTATION_COMPONENT_BONE_ORIENTATION_NO }}
						</label>
					</div>
					@if (isCorrect() == null && isValidationForced()) {
					<div class="invalid-feedback d-block">{{ labels().VALIDATION_MESSAGE_REQUIRED_ORIENTATION }}</div>
					}
				</div>

				<div class="col-10 mx-auto mt-3">
					<div data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_INFO_BOX" class="box-img-setup">
						<div class="wrapper-img">
							<div data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_INFO_LEFT_LBL" class="btn-xray left">
								{{ orientLeftLabel() }}
							</div>
							@if (orientUpLabel()) {
							<div data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_INFO_TOP_LBL" class="btn-xray top">
								{{ orientUpLabel() }}
							</div>
							}
							<img [src]="imgOrientationSrc" alt="">
							<div data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_INFO_RIGHT_LBL" class="btn-xray right">
								{{ orientRightLabel() }}
							</div>
							@if (orientDownLabel()) {
							<div data-testid="SUBSYS2_CATEGORIZATION_ORIENTATION_INFO_BOTTOM_LBL" class="btn-xray bottom">
								{{ orientDownLabel() }}
							</div>
							}
						</div>
					</div>
				</div>
			</div>

		</form>

	</div>
</div>